import { Navigate, type RouteObject } from 'react-router-dom';
import { MainLayout } from '@/features/layout';
import { HomePage } from '@/features/home';
import { AuthGuard } from '@/features/auth/components/AuthGuard';
import { AuthCallbackPage } from '@/features/auth/pages/AuthCallbackPage';
import { SSORedirectPage } from '@/features/auth/pages/SSORedirectPage';
import { ProfilePage, BlogPage, PostDetailPage, CreatePostPage, EditPostPage, BlogLayout } from '@/features/blog';
import PrivacyPolicyPage from '@/features/policies/pages/PrivacyPolicyPage';
import TermsOfServicePage from '@/features/policies/pages/TermsOfServicePage';

export const routeDefinitions: RouteObject[] = [
  // Auth routes
  {
    path: '/auth',
    children: [
      { path: 'login', element: <SSORedirectPage returnTo="/" /> },
      { path: 'register', element: <SSORedirectPage returnTo="/" /> },
      { path: 'callback', element: <AuthCallbackPage /> },
      {
        index: true,
        element: <Navigate to="/auth/login" replace />,
      },
    ],
  },

  // Main application routes
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      // Protected Profile Page
      {
        path: 'profile',
        element: (
          <AuthGuard>
            <ProfilePage />
          </AuthGuard>
        ),
      },
      // Policy pages (static)
      {
        path: 'policies/privacy-policy',
        element: <PrivacyPolicyPage />,
      },
      {
        path: 'policies/term-of-service',
        element: <TermsOfServicePage />,
      },
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ],
  },

  // Blog routes - No header/footer for immersive experience
  {
    path: '/',
    element: <BlogLayout />,
    children: [
      // Public Blog Page
      {
        path: 'blogs/:slug',
        element: <BlogPage />,
      },
      // Protected Create Post Page
      {
        path: 'blogs/:blogSlug/create-post',
        element: (
          <AuthGuard>
            <CreatePostPage />
          </AuthGuard>
        ),
      },
      // Public Post Detail Page
      {
        path: 'posts/:slug',
        element: <PostDetailPage />,
      },
      // Protected Edit Post Page
      {
        path: 'posts/:slug/edit',
        element: (
          <AuthGuard>
            <EditPostPage />
          </AuthGuard>
        ),
      },
    ],
  },

  // Redirect any other path to home
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
];
